import { WrappedAxios } from "./wrapped-axios"

// LoggedAxios
export const Laxios = () => {
    return new WrappedAxios()
}
